import blank from 'assets/readmeTemplates/blank.md';
import connectedDevices from 'assets/readmeTemplates/connectedDevices.md';

import OSH_assembly from 'assets/readmeTemplates/OSH_assembly.md';
import OSH_design from 'assets/readmeTemplates/OSH_design.md';
import OSH_disposal from 'assets/readmeTemplates/OSH_disposal.md';
import OSH_introduction from 'assets/readmeTemplates/OSH_introduction.md';
import OSH_maintenance from 'assets/readmeTemplates/OSH_maintenance.md';
import OSH_manufacturing from 'assets/readmeTemplates/OSH_manufacturing.md';
import OSH_specifications from 'assets/readmeTemplates/OSH_specifications.md';
import OSH_use from 'assets/readmeTemplates/OSH_use.md';

const templateMap = {
  'blank.md': blank,
  'connectedDevices.md': connectedDevices,
  'OSH_introduction.md': OSH_introduction,
  'OSH_specifications.md': OSH_specifications,
  'OSH_design.md': OSH_design,
  'OSH_manufacturing.md': OSH_manufacturing,
  'OSH_assembly.md': OSH_assembly,
  'OSH_use.md': OSH_use,
  'OSH_maintenance.md': OSH_maintenance,
  'OSH_disposal.md': OSH_disposal,
};

export default templateMap;
